import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import VehicleList from "../components/VehicleList";
import SparePartsList from "../components/SparePartsList";
import { sanityClient } from "../lib/sanityClient";
import { Helmet } from "react-helmet-async";

const CategoryPage = () => {
  const { slug } = useParams();
  const [category, setCategory] = useState(null);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!slug) {
      setLoading(false);
      return;
    }

    const fetchCategoryData = async () => {
      try {
        // Fetch category details
        const categoryQuery = `*[_type == "category" && slug.current == $slug][0]`;
        const fetchedCategory = await sanityClient.fetch(categoryQuery, { slug });

        if (!fetchedCategory) {
          setLoading(false);
          return;
        }

        setCategory(fetchedCategory);

        let query = "";
        if (slug === "used-cars" || slug === "brand-new-cars") {
          query = `*[_type == "vehicle" && $categoryId in categories[]._ref]{
            _id, title, price, condition, brand, model, year, primaryImage
          }`;
        } else if (slug === "spare-parts") {
          query = `*[_type == "sparePart" && $categoryId in categories[]._ref]{
            _id, name, price, description, compatibility, primaryImage
          }`;
        }

        if (query) {
          const fetchedItems = await sanityClient.fetch(query, { categoryId: fetchedCategory._id });
          setItems(fetchedItems);
        }
      } catch (error) {
        console.error("Error fetching category data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCategoryData();
  }, [slug]);

  if (loading) {
    return <div className="text-center mt-8">Loading...</div>;
  }

  return (
    <div className="category-page container mx-auto px-4 py-8">
      <Helmet>
        <title>{category?.title || "Category"}</title>
        <meta name="description" content={category?.description || "Browse our category"} />
      </Helmet>
      <div className="text-center mb-8">
        <h1 className="text-4xl font-bold">{category?.title || "Category Not Found"}</h1>
        <p className="text-lg text-gray-600 mt-2">{category?.description || "No details available."}</p>
      </div>
      <div>
        {slug === "used-cars" || slug === "brand-new-cars" ? (
          <VehicleList categorySlug={slug} />
        ) : slug === "spare-parts" ? (
          <SparePartsList spareParts={items} />
        ) : (
          <p className="text-center text-gray-500">No items available for this category.</p>
        )}
      </div>
    </div>
  );
};

export default CategoryPage;
